import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import favoritesMenuService from "../../services/favoritesMenuService";

export const getFavoriteList = createAsyncThunk("favoritesMenu/getFavoriteList", async (data, {rejectWithValue}) => {
    try {
        return await favoritesMenuService.getFavoriteList();
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const deleteFavorite = createAsyncThunk("favoritesMenu/deleteFavorite", async (module, {rejectWithValue, dispatch}) => {
    try {
        const response = await favoritesMenuService.deleteFavorite(module);
        if(response?.status === 200) {
            dispatch(getFavoriteList());
        }
        return response.data;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const addFavorite = createAsyncThunk("favoritesMenu/addFavorite", async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await favoritesMenuService.addFavorite(data);
        if(response?.status === 200) {
            dispatch(getFavoriteList());
        }
        return response.data;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const reorderFavoriteList = createAsyncThunk("favoritesMenu/reorderFavoriteList", async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await favoritesMenuService.reorderFavoriteList(data);
        if(response?.status === 200) {
            dispatch(getFavoriteList());
        }
        return response.data;
    } catch (error) {
        return rejectWithValue(error);
    }
});

const initialState = {
    favoriteList : [],
};

export const favoritesMenuSlice = createSlice({
    name: 'favoritesMenuSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(getFavoriteList.fulfilled, (state, action) => {
            state.favoriteList = action.payload.data?.favoriteMenuList;
        });

        builder.addCase(getFavoriteList.pending, (state, action) => {
        });

        builder.addCase(getFavoriteList.rejected, (state, action) => {
            state.favoriteList = [];
        });
    }
});

export const {
} = favoritesMenuSlice.actions;

export default favoritesMenuSlice.reducer;

